// extracted by mini-css-extract-plugin
module.exports = {"features":"features-module--features--jECZ0"};